import { useState, useEffect } from "react";
import { useObjectStore } from "../zustand/objects";
import { useThree } from "@react-three/fiber";
import { Box } from "@react-three/drei";
import * as THREE from 'three';

export function CommentCursor({type, threadsId, artboard, position}) {

    const { camera, raycaster, mouse, scene } = useThree();

    const {
            currentObjectArtboard,
            updateArtboard,
            artboards,
            storyboardFields,
            commentClickStatus,
            handleNewThreadClick,
            handleCommentButtonClick,
            addThread,
            updateThread
        } = useObjectStore();

    useEffect(() => {
        const handleClick = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            raycaster.setFromCamera(mouse, camera);

            const intersects = raycaster.intersectObjects(scene.children, true);

            if (intersects.length > 0) {            
                const intersectionPoint = intersects[0].point;
                if (commentClickStatus.clicking === "add") {
                addThread(intersectionPoint)}
                else if (commentClickStatus.clicking === "move") {
                    updateThread(threadsId, artboard, intersectionPoint)
                }
            } else {
                return
            }
        };

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, [camera, raycaster, mouse, scene]);

    return null;
}


export function MoveCommentCursor({type, threadsId, artboard, position}) {

    const { camera, raycaster, mouse, scene } = useThree();

    const {
            currentObjectArtboard,
            updateArtboard,
            artboards,
            storyboardFields,
            commentClickStatus,
            handleNewThreadClick,
            handleCommentButtonClick,
            addThread,
            updateThread
        } = useObjectStore();

    useEffect(() => {
        const handleClick = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            raycaster.setFromCamera(mouse, camera);

            const intersects = raycaster.intersectObjects(scene.children, true);

            if (intersects.length > 0) {

                const intersectionPoint = intersects[0].point;
                if (commentClickStatus.clicking === "add") {
                addThread(intersectionPoint)}
                else if (commentClickStatus.clicking === "move") {
                    
                    updateThread(threadsId, artboard, position)
                }
            } else {
                return
            }
        };

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, [camera, raycaster, mouse, scene]);

    return null;
}